import { createReducer, on } from '@ngrx/store';
import {
  addEvent,
  addEventFailed,
  addEventReceived,
  addOperatingAutorities,
  addOperatingAutoritiesReceived,
  addReturningGuest,
  addReturningGuestFailed,
  addReturningGuestReceived,
  deleteReturningGuest,
  deleteReturningGuestFailed,
  deleteReturningGuestSuccessfull,
  editEvent,
  editEventFailed,
  editEventReceived,
  editReturningGuest,
  editReturningGuestFailed,
  editReturningGuestReceived,
  getEvents,
  getEventsFailed,
  getEventsReceived,
  getFees,
  getFeesAndInvoices,
  getFeesAndInvoicesReceived,
  getFeesFailed,
  getFeesRecieved,
  getInvoices,
  getInvoicesFailed,
  getInvoicesRecieved,
  getNotificationMessage,
  getNotificationMessageFailed,
  getNotificationMessageReceived,
  getNotifications,
  getNotificationsFailed,
  getNotificationsReceived,
  getOperatingAuthoritiesReceived,
  getOperatingAutorities,
  getPaymentHistory,
  getPaymentHistoryReceived,
  getPaymentHistoryRecievedFailed,
  getReturningGuests,
  getReturningGuestsFailed,
  getReturningGuestsReceived,
  getTerminals,
  getTerminalsFailed,
  getTerminalsReceived,
  showApplicationInfoPopup,
  showApplicationInfoPopupList,
  showPopup,
  terminateEvent,
  terminateEventFailed,
  terminateEventReceived,
} from '../actions/operatingAuthorityAction';
import { operatingAuthityStateDataType } from '../../core/models/Interfaces/operatingAuthority';

const initialState: operatingAuthityStateDataType = {
  isFetchingoperatingAuthority: false,
  operatingAuthorityData: null,
  feesAndInvoicesData: null,
  isfetchingFeesAndInvoices: false,
  isSubmittingoperatingAuthority: false,
  operatingAuthoritiesData: null,
  isFetchingFees: false,
  feesData: null,
  isFetchingInvoices: false,
  invoicesData: null,
  paymentHistoryData: null,
  isFetchingPaymentHistory: false,
  isFetchingNotifications: false,
  notificationsData: null,
  isFetchingNotificationMessage: false,
  notificationMessageData: null,
  terminalsData: null,
  isFetchingTerminals: false,
  eventsData: null,
  isFetchingEvents: false,
  addEventData: null,
  isAddingEvent: false,
  isEditingEvent: false,
  isTerminatingEvent: false,
  returningGuestsData: null,
  isFetchingReturningGuests: false,
  isEditingReturningGuest: false,
  addReturningGuestData: null,
  isAddingReturningGuest: false,
  showPopupData: null,
  showApplicationInfoPopupData: null,
  showApplicationInfoPopupListData: null,
};

export const operatingAuthorityReducer = createReducer(
  initialState,
  on(getOperatingAuthoritiesReceived, (state, data) => {
    return {
      ...state,
      isFetchingoperatingAuthority: false,
      operatingAuthorityData: data.params,
    };
  }),
  on(getOperatingAutorities, (state, data) => {
    return {
      ...state,
      isFetchingoperatingAuthority: true,
    };
  }),

  on(getFees, (state, data) => {
    return {
      ...state,
      isFetchingFees: true,
    };
  }),
  on(getFeesRecieved, (state, data) => {
    return {
      ...state,
      feesData: data.params,
      isFetchingFees: false,
    };
  }),
  on(getFeesFailed, (state, data) => {
    return {
      ...state,
      isFetchingFees: false,
    };
  }),

  on(getInvoices, (state, data) => {
    return {
      ...state,
      isFetchingInvoices: true,
    };
  }),
  on(getInvoicesRecieved, (state, data) => {
    return {
      ...state,
      invoicesData: data.params,
      isFetchingInvoices: false,
    };
  }),
  on(getInvoicesFailed, (state, data) => {
    return {
      ...state,
      isFetchingInvoices: false,
    };
  }),

  on(getPaymentHistory, (state, data) => {
    return {
      ...state,
      isFetchingPaymentHistory: true,
    };
  }),
  on(getPaymentHistoryReceived, (state, data) => {
    return {
      ...state,
      paymentHistoryData: data.params,
      isFetchingPaymentHistory: false,
    };
  }),
  on(getPaymentHistoryRecievedFailed, (state, data) => {
    return {
      ...state,
      isFetchingPaymentHistory: false,
    };
  }),

  on(getFeesAndInvoices, (state) => {
    return {
      ...state,
      isfetchingFeesAndInvoices: true,
    };
  }),
  on(getFeesAndInvoicesReceived, (state, data) => {
    return {
      ...state,
      feesAndInvoicesData: data.params,
      isfetchingFeesAndInvoices: false,
    };
  }),

  on(addOperatingAutorities, (state, data) => {
    return {
      ...state,
      isSubmittingoperatingAuthority: true,
    };
  }),
  on(addOperatingAutoritiesReceived, (state, data) => {
    return {
      ...state,
      isSubmittingoperatingAuthority: false,
      operatingAuthoritiesData: data.params,
    };
  }),

  on(getNotifications, (state, data) => {
    return {
      ...state,
      isFetchingNotifications: true,
    };
  }),
  on(getNotificationsReceived, (state, data) => {
    return {
      ...state,
      notificationsData: data.params,
      isFetchingNotifications: false,
    };
  }),
  on(getNotificationsFailed, (state, data) => {
    return {
      ...state,
      isFetchingNotifications: false,
    };
  }),

  on(getNotificationMessage, (state, data) => {
    return {
      ...state,
      isFetchingNotificationMessage: true,
    };
  }),
  on(getNotificationMessageReceived, (state, data) => {
    return {
      ...state,
      notificationMessageData: data.params,
      isFetchingNotificationMessage: false,
    };
  }),
  on(getNotificationMessageFailed, (state, data) => {
    return {
      ...state,
      isFetchingNotificationMessage: false,
    };
  }),

  on(getTerminals, (state, data) => {
    return {
      ...state,
      isFetchingTerminals: true,
    };
  }),
  on(getTerminalsReceived, (state, data) => {
    return {
      ...state,
      terminalsData: data.params,
      isFetchingTerminals: false,
    };
  }),
  on(getTerminalsFailed, (state, data) => {
    return {
      ...state,
      isFetchingTerminals: false,
    };
  }),

  on(getEvents, (state, data) => {
    return {
      ...state,
      isFetchingEvents: true,
      isAddingEvent: false,
    };
  }),
  on(getEventsReceived, (state, data) => {
    return {
      ...state,
      eventsData: data.params,
      isFetchingEvents: false,
    };
  }),
  on(getEventsFailed, (state, data) => {
    return {
      ...state,
      isFetchingEvents: false,
    };
  }),

  on(addEvent, (state, data) => {
    return {
      ...state,
      isAddingEvent: true,
    };
  }),
  on(addEventReceived, (state, data) => {
    return {
      ...state,
      isAddingEvent: false,
      addEventData: data.params,
    };
  }),
  on(addEventFailed, (state, data) => {
    return {
      ...state,
      isAddingEvent: false,
    };
  }),

  on(editEvent, (state) => {
    return { ...state, isEditingEvent: true };
  }),
  on(editEventReceived, (state) => {
    return { ...state, isEditingEvent: false };
  }),
  on(editEventFailed, (state) => {
    return { ...state, isEditingEvent: false };
  }),

  on(terminateEvent, (state) => {
    return { ...state, isTerminatingEvent: true };
  }),
  on(terminateEventReceived, (state) => {
    return { ...state, isTerminatingEvent: false };
  }),
  on(terminateEventFailed, (state) => {
    return { ...state, isTerminatingEvent: false };
  }),

  on(getReturningGuests, (state, data) => {
    return {
      ...state,
      isFetchingReturningGuests: true,
    };
  }),
  on(getReturningGuestsReceived, (state, data) => {
    return {
      ...state,
      returningGuestsData: data.params,
      isFetchingReturningGuests: false,
    };
  }),
  on(getReturningGuestsFailed, (state, data) => {
    return {
      ...state,
      isFetchingReturningGuests: false,
    };
  }),

  on(addReturningGuest, (state, data) => {
    return {
      ...state,
      isAddingReturningGuest: true,
    };
  }),
  on(addReturningGuestReceived, (state, data) => {
    return {
      ...state,
      isAddingReturningGuest: false,
      addReturningGuestData: data.params,
    };
  }),
  on(addReturningGuestFailed, (state, data) => {
    return {
      ...state,
      isAddingReturningGuest: false,
    };
  }),

  on(editReturningGuest, (state) => {
    return { ...state, isEditingReturningGuest: true };
  }),
  on(editReturningGuestReceived, (state) => {
    return { ...state, isEditingReturningGuest: false };
  }),
  on(editReturningGuestFailed, (state) => {
    return { ...state, isEditingReturningGuest: false };
  }),

  on(deleteReturningGuest, (state) => {
    return { ...state, deleteContactsSubmitting: true };
  }),
  on(deleteReturningGuestSuccessfull, (state) => {
    return { ...state, deleteContactsSubmitting: false };
  }),
  on(deleteReturningGuestFailed, (state) => {
    return { ...state, deleteContactsSubmitting: false };
  }),

  on(showPopup, (state, data) => {
    return {
      ...state,
      showPopupData: data.params,
    };
  }),

  on(showApplicationInfoPopup, (state, data) => {
    return {
      ...state,
      showApplicationInfoPopupData: data.params,
    };
  }),

  on(showApplicationInfoPopupList, (state, data) => {
    return {
      ...state,
      showApplicationInfoPopupListData: data.params,
    };
  }),
);
